export default __webpack_public_path__ + "static/media/b3.90a6fc0a.svg";